export interface PostConfig {
  naInitialValue: string;
  euInitialValue: string;
  saInitialValue: string;
  availableForWorkflow: boolean;
  availableForPlantPosts: boolean;
  labelKey: string;
}

export const EGRA_POSTS: Record<string, PostConfig> = {
  ADJUSTMENT: {
    naInitialValue: 'REQUIRED',
    euInitialValue: 'REQUIRED',
    saInitialValue: 'REQUIRED',
    availableForWorkflow: false,
    availableForPlantPosts: true,
    labelKey: 'adjustmentText'
  },
  BUFFER: {
    naInitialValue: 'REQUIRED',
    euInitialValue: 'REQUIRED',
    saInitialValue: 'REQUIRED',
    availableForWorkflow: true,
    availableForPlantPosts: true,
    labelKey: 'bufferText'
  },
  BUILDER: {
    naInitialValue: 'REQUIRED',
    euInitialValue: 'REQUIRED',
    saInitialValue: 'REQUIRED',
    availableForWorkflow: true,
    availableForPlantPosts: true,
    labelKey: 'builderText'
  },
  CASING_EDIT: {
    naInitialValue: 'YES',
    euInitialValue: 'YES',
    saInitialValue: 'YES',
    availableForWorkflow: false,
    availableForPlantPosts: false,
    labelKey: 'Casing Edit'
  },
  CEMENT_FILL: {
    naInitialValue: 'NO',
    euInitialValue: 'NO',
    saInitialValue: 'NO',
    availableForWorkflow: true,
    availableForPlantPosts: true,
    labelKey: 'cementFillText'
  },
  CHAMBER: {
    naInitialValue: 'YES',
    euInitialValue: 'YES',
    saInitialValue: 'YES',
    availableForWorkflow: true,
    availableForPlantPosts: true,
    labelKey: 'chamberText'
  },
  CIA: {
    naInitialValue: 'REQUIRED',
    euInitialValue: 'REQUIRED',
    saInitialValue: 'REQUIRED',
    availableForWorkflow: true,
    availableForPlantPosts: true,
    labelKey: 'ciaText'
  },
  CUSTOM_MOLD: {
    naInitialValue: 'YES',
    euInitialValue: 'YES',
    saInitialValue: 'YES',
    availableForWorkflow: false,
    availableForPlantPosts: true,
    labelKey: 'customMoldText'
  },
  FINAL_INSPECTION: {
    naInitialValue: 'REQUIRED',
    euInitialValue: 'REQUIRED',
    saInitialValue: 'REQUIRED',
    availableForWorkflow: true,
    availableForPlantPosts: true,
    labelKey: 'finalInspectionText'
  },
  INITIAL_INSPECTION: {
    naInitialValue: 'REQUIRED',
    euInitialValue: 'REQUIRED',
    saInitialValue: 'REQUIRED',
    availableForWorkflow: true,
    availableForPlantPosts: true,
    labelKey: 'initialInspectionText'
  },
  PRE_MOLD: {
    naInitialValue: 'REQUIRED',
    euInitialValue: 'REQUIRED',
    saInitialValue: 'REQUIRED',
    availableForWorkflow: false,
    availableForPlantPosts: true,
    labelKey: 'preMoldText'
  },
  REJECT: {
    naInitialValue: 'REQUIRED',
    euInitialValue: 'REQUIRED',
    saInitialValue: 'REQUIRED',
    availableForWorkflow: false,
    availableForPlantPosts: true,
    labelKey: 'actionRejectText'
  },
  RECEIVING: {
    naInitialValue: 'NO',
    euInitialValue: 'NO',
    saInitialValue: 'NO',
    availableForWorkflow: false,
    availableForPlantPosts: false,
    labelKey: 'receivingText'
  },
  REPAIR: {
    naInitialValue: 'REQUIRED',
    euInitialValue: 'REQUIRED',
    saInitialValue: 'REQUIRED',
    availableForWorkflow: true,
    availableForPlantPosts: true,
    labelKey: 'repairText'
  },
  SERVICE: {
    naInitialValue: 'YES',
    euInitialValue: 'YES',
    saInitialValue: 'YES',
    availableForWorkflow: false,
    availableForPlantPosts: true,
    labelKey: 'serviceText'
  },
  SHIPPING: {
    naInitialValue: 'NO',
    euInitialValue: 'NO',
    saInitialValue: 'NO',
    availableForWorkflow: false,
    availableForPlantPosts: false,
    labelKey: 'shippingText'
  },
  SKIVE: {
    naInitialValue: 'YES',
    euInitialValue: 'YES',
    saInitialValue: 'YES',
    availableForWorkflow: true,
    availableForPlantPosts: true,
    labelKey: 'skiveText'
  },
  TREAD_PREPARATION: {
    naInitialValue: 'NO',
    euInitialValue: 'NO',
    saInitialValue: 'NO',
    availableForWorkflow: false,
    availableForPlantPosts: true,
    labelKey: 'treadPreparationText'
  },
  RFID_ADMIN: {
    naInitialValue: 'YES',
    euInitialValue: 'YES',
    saInitialValue: 'YES',
    availableForWorkflow: false,
    availableForPlantPosts: false,
    labelKey: 'rfidAdminText'
  },
  RFID_INSTALLATION: {
    naInitialValue: 'YES',
    euInitialValue: 'YES',
    saInitialValue: 'YES',
    availableForWorkflow: true,
    availableForPlantPosts: false,
    labelKey: 'rfidInstallationText'
  },
  RFID_QUICK_SCAN: {
    naInitialValue: 'YES',
    euInitialValue: 'YES',
    saInitialValue: 'YES',
    availableForWorkflow: false,
    availableForPlantPosts: false,
    labelKey: 'rfidQuickScanText'
  },
  SIDEWALL_RENEWAL: {
    naInitialValue: 'NO',
    euInitialValue: 'NO',
    saInitialValue: 'NO',
    availableForWorkflow: false,
    availableForPlantPosts: false,
    labelKey: 'sidewallRenewalText'
  }
};
